import { render, staticRenderFns } from "./FoulingDetailsSection.vue?vue&type=template&id=3120ea16&scoped=true&"
import script from "./FoulingDetailsSection.vue?vue&type=script&lang=js&"
export * from "./FoulingDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./FoulingDetailsSection.vue?vue&type=style&index=0&id=3120ea16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120ea16",
  null
  
)

export default component.exports